module.exports = __webpack_public_path__ + "static/media/201ME106.5ba14909.jpg";